import { PageHero } from "@/components/site/PageHero";
import { Container } from "@/lib/ui";
import { COMPANY } from "@/data/site";

const PRIVACY = {
  id: "privacy",
  overline: "Legal",
  title: "Privacy Policy",
  sections: [
    ["Overview", `${COMPANY.name} ("GreatLeaf", "we", "us") respects your privacy. This policy explains how we collect, use and protect information submitted through this website.`],
    ["Information We Collect", "We collect information you provide directly — such as your name, company, email, phone number, investor type, asset class and message — when you submit an inquiry or contact form. We may also collect standard technical data such as browser type and pages visited."],
    ["How We Use Information", "We use submitted information to respond to inquiries, provide proposals, communicate about our services, and improve our website. We do not sell your personal information."],
    ["Sharing", "We share information only with service providers who help us operate our business (for example, email and hosting providers) and where required by law. These providers are bound by confidentiality obligations."],
    ["Data Retention", "We retain inquiry information for as long as necessary to respond and to maintain business records, unless a longer retention period is required by law."],
    ["Your Choices", "You may request access to, correction of, or deletion of your personal information by contacting us using the details below."],
    ["Contact", `For privacy questions, contact us at ${COMPANY.phone}.`],
  ],
};

const TERMS = {
  id: "terms",
  overline: "Legal",
  title: "Terms of Use",
  sections: [
    ["Acceptance", `By accessing this website, you agree to these Terms of Use. If you do not agree, please do not use the site.`],
    ["No Offer or Advice", "Information on this site is provided for general informational purposes only. It does not constitute an offer, solicitation, or recommendation, and is not investment, legal, tax, or financial advice. Nothing on this site should be relied upon as a promise or representation of future performance."],
    ["Performance Information", "Any metrics or illustrations shown are for general illustrative purposes and do not guarantee future results. Actual performance depends on numerous factors specific to each asset and mandate."],
    ["Intellectual Property", `All content, trademarks and materials on this site are owned by ${COMPANY.name} or its licensors and may not be reproduced without permission.`],
    ["Limitation of Liability", "The site is provided \u201cas is\u201d without warranties of any kind. To the fullest extent permitted by law, we are not liable for any damages arising from use of the site."],
    ["Governing Law", "These terms are governed by the laws of the State in which GreatLeaf Management maintains its principal place of business, without regard to conflict-of-laws principles."],
    ["Contact", `Questions about these terms may be directed to us at ${COMPANY.phone}.`],
  ],
};

export default function Legal({ kind }) {
  const c = kind === "terms" ? TERMS : PRIVACY;
  return (
    <>
      <PageHero id={c.id} overline={c.overline} title={c.title} />
      <section className="py-24 md:py-32 bg-white">
        <Container>
          <div className="max-w-3xl space-y-10">
            {c.sections.map(([h, body]) => (
              <div key={h}>
                <h2 className="font-display text-2xl text-[#121A16] mb-3">{h}</h2>
                <p className="text-[#5C6660] leading-relaxed">{body}</p>
              </div>
            ))}
            <p className="text-sm text-[#8A918B] pt-6 border-t border-[#E5E5DF]">Last updated: {new Date().getFullYear()}.</p>
          </div>
        </Container>
      </section>
    </>
  );
}
